import { getInstance } from "./db";

export const minutely = 60 * 1000;
export const hourly = 60 * minutely;
export const daily = 24 * hourly;

export const storage = getInstance("data");
